<template>
  <div class="stat">
    <div class="stat-metric">{{ metric }}</div>
    <div class="stat-value">{{ value }}</div>
  </div>
</template>

<script>
export default {
  props: ['metric', 'value']
}
</script>

<style scoped>
.stat {
  color: #aaa;
}

.stat .stat-metric {
  display: inline-block;
  width: 100px;
  text-align: left;
}
.stat .stat-value {
  display: inline-block;
  width: 100px;
  text-align: right;
  font-family: Consolas, 'Courier New', Courier, monospace;
}
</style>
